import { jsx as r } from "react/jsx-runtime";
import { StyledRadioLabel as d, StyledRadio as l } from "./styles48.mjs";
import { TEST_IDS as m } from "./testIds.mjs";
import { Stack as c } from "@mui/material";
const $ = ({
  label: e,
  hasError: o = !1,
  radioPlacement: t = "center",
  helperText: n,
  disabled: a = !1,
  ...i
}) => /* @__PURE__ */ r(c, { direction: "column", gap: 0, children: /* @__PURE__ */ r(
  d,
  {
    label: e,
    $radioPlacement: t,
    $hasError: o,
    control: /* @__PURE__ */ r(
      l,
      {
        $radioPlacement: t,
        $hasError: o,
        disabled: a,
        "data-testid": m.radio,
        ...i
      }
    )
  }
) });
export {
  $ as Radio
};
//# sourceMappingURL=index72.mjs.map
